import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { isNullOrUndefined } from '@sla-ng/core';
import { distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICostUnitContributionMargin } from '../../models/cost-unit-contribution-margin';
import { ICostUnit } from '../../models/cost-unit.model';
import { CostUnitCostFacade } from '../../services/facades/cost-accounting/cost-unit-cost.facade';
import { ISharedDataState } from '../../services/facades/master-data/shared-data-state.model';
import { SharedDataFacade } from '../../services/facades/master-data/shared-data.facade';

@Component({
    selector: 'app-break-even-list',
    templateUrl: './break-even-list.component.html',
    styleUrls: [ './break-even-list.component.css' ],
})
export class BreakEvenListComponent implements OnInit, AfterViewInit {

    @ViewChild(MatSort)
    public sort: MatSort;

    @Input()
    public set costAccountingId(costAccountingId: number) {
        if (!isNullOrUndefined(costAccountingId)) {
            void this.setData(costAccountingId);
        }
    }

    public destroy$: Subject<void> = new Subject<void>();
    public columns = [ 'costUnit', 'articleNr' ,'revenue', 'variableCost', 'contributionMarginLevel1' ];

    public sharedDataState$: Observable<ISharedDataState>;

    public dataSource: MatTableDataSource<ICostUnitContributionMargin> = new MatTableDataSource<ICostUnitContributionMargin>([]);

    constructor(private myCostUnitCostFacade: CostUnitCostFacade,
                private mySharedDataFacade: SharedDataFacade) {
    }

    public ngOnInit(): void {
        this.sharedDataState$ = this.mySharedDataFacade.subState();

        this.sharedDataState$.pipe(
            takeUntil(this.destroy$),
            map((state: ISharedDataState) => state.costUnitLookup),
            distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
        ).subscribe((costUnitLookup: Record<string, ICostUnit>) => {

            this.dataSource.filterPredicate = (data: ICostUnitContributionMargin, filter: string): boolean => {
                const foundCostUnit = costUnitLookup[ data.costUnitId ];
                return foundCostUnit?.name.toLowerCase().includes(filter)
                    || foundCostUnit?.articleNr.toLowerCase().includes(filter);
            };
        });
    }

    public applyFilter(value: string): void {
        this.dataSource.filter = value.trim().toLowerCase();
    }

    public ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
    }

    private async setData(costAccountingId: number): Promise<void> {
        this.dataSource.data = await this.myCostUnitCostFacade.getBreakEvenComparison(costAccountingId);
    }
}
